import { apiClient, makeServicePlugin, BaseModel } from '@/api'

class Role extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Role'
  // Define default properties here
  static instanceDefaults() {
    return {
      name: null,
      description: null,
      account_id: null,
      system: false
    }
  }
}

const servicePath = 'roles'
const servicePlugin = makeServicePlugin({
  Model: Role,
  service: apiClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
apiClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin